export default function initHeader() {

  Alpine.data('header', () => ({
    open: false,
    selectedSection: '',
    hoveredSection: '',
    hero: null as HTMLElement | null,
    autohideElement: null as HTMLElement | null,
    lastScrollTop: 0,
    init() {
      this.autohideElement = document.getElementById('header');
      this.hero = document.querySelector('.hero');

      if (this.autohideElement) {
        document.addEventListener('DOMContentLoaded', () => {
          window.addEventListener('scroll', () => {
            this.positionHeader();
          });
          this.positionHeader();
          setTimeout(() => this.autohideElement && this.autohideElement.classList.remove('hidden'), 300);
        });
      }

      window.addEventListener('keydown', (event: KeyboardEvent) => this.closeMenuOnEsc(event));
    },
    positionHeader() {
      if (this.autohideElement) {
        const {body} = document;
        const scrollTop = window.scrollY;
        if (scrollTop < 70) {
          this.autohideElement.classList.add('scrolled-top');
          this.autohideElement.classList.remove('scrolled-down', 'scrolled-to-hero', 'scrolled-up');

          body.classList.add('scrolled-top');
          body.classList.remove('scrolled-down', 'scrolled-up');
        } else if (scrollTop < this.lastScrollTop) {
          if (!this.hero || scrollTop > this.hero.clientHeight) {
            this.autohideElement.classList.remove('scrolled-top', 'scrolled-to-hero', 'scrolled-down');
            this.autohideElement.classList.add('scrolled-up');

            body.classList.remove('scrolled-top');
            body.classList.add('scrolled-up');
          } else {
            this.autohideElement.classList.remove('scrolled-top', 'scrolled-up');
            this.autohideElement.classList.add('scrolled-to-hero');

            body.classList.remove('scrolled-top', 'scrolled-up');
          }
        } else {
          this.autohideElement.classList.remove('scrolled-top', 'scrolled-up');
          this.autohideElement.classList.add('scrolled-down');

          body.classList.remove('scrolled-top', 'scrolled-up');
          body.classList.add('scrolled-down');
        }
        this.lastScrollTop  = scrollTop;
      }
    },
    closeMenuOnEsc(event: KeyboardEvent) {
      if (event.key === 'Escape' && this.open) {
          this.closeDialog();
      }
    },
    accountMenuClasses() {
      return this.open ? 'max-lg:flex max-lg:opacity-100' : 'max-lg:hidden max-lg:opacity-0';
    },
    buttonClasses() {
      return this.selectedSection !== '' ? 'max-lg:hidden' : 'max-lg:flex';
    },
    linkClasses() {
      return this.selectedSection !== '' ? 'max-lg:hidden' : 'max-lg:inline';
    },
    openMenuSectionOpen() {
      const button = this.$el;
      const { key } = button.dataset;
      if (key) {
        this.selectedSection = key;
      }
    },
    toggleMenuSectionOpen() {
      const button = this.$el;
      const { key } = button.dataset;
      if (this.selectedSection === key) {
        this.selectedSection = '';
      } else if (key) {
        this.selectedSection = key;
      }
    },
    hoverMenuSectionOpen() {
      const button = this.$el;
      const { key } = button.dataset;
      if (key) {
        this.hoveredSection = key;
      }
    },
    menuSectionOpenClasses(key: string) {
      return this.selectedSection === key ? 'max-lg:[&>ul]:flex max-lg:translate-x-0' : 'max-lg:[&>ul]:hidden max-lg:translate-x-[calc(100%_+_48px)]';
    },
    itemClasses(key: string) {
      return this.selectedSection === key || this.hoveredSection === key ? 'hovered' : '';
    },
    backToPreviousSection() {
      const key = this.selectedSection;
      this.selectedSection = '';
      this.hoveredSection = '';
      if (key) {
        const button = document.querySelector(`button[data-key="${key}"]`) as HTMLButtonElement;
        if (button) {
          setTimeout(() => button.focus(), 100);
        }
      }
    },
    toggleMenu() {
      if (this.open) {
        this.closeDialog();
      } else {
        this.openDialog();
      }
    },
    openDialog() {
      this.open = true;
      document.documentElement.classList.add('nav-active');
      document.body.classList.add('nav-active');
    },
    closeDialog() {
      this.open = false;
      document.documentElement.classList.remove('nav-active');
      document.body.classList.remove('nav-active');
      this.backToPreviousSection();
    },
    dialogClasses() {
      return this.open ? 'visible max-lg:translate-x-0 lg:opacity-100' : 'invisible max-lg:translate-x-full lg:opacity-0';
    },
  }));
}
